export default function NotFound() {
    return (
        <div className="min-h-screen bg-[#050507] text-white grid place-items-center px-6" data-testid="not-found">
            <div className="text-center">
                <div className="overline">404</div>
                <h1 className="mt-3 font-serif-display text-5xl">Page not <span className="italic text-[#D4AF37]">found</span></h1>
                <a href="/" className="btn-gold mt-8 inline-flex">Back home</a>
            </div>
        </div>
    );
}
